module.exports = __webpack_public_path__ + "static/assets/a13569c3e30663c32c142b5faf389957.png";